module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_m_normal.e79af527.png";